import CropImageRequest from '../../../../RunPay/Admin/IServices/Models/Common/CropImageRequest';

export default class SaveNewsTranslation  {
	LangCode?: string = '';
	Name?: string = '';
	Description?: string = '';
	Image: CropImageRequest = null;
	constructor(obj?: Partial<SaveNewsTranslation>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/IServices/Models/SaveNewsTranslation.ts